const defaultSlider = {
  perView: 5,
  perSwipe: "|",
  autoplay: 0
};

export { defaultSlider };
